import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { api } from "../../environments/environment";
import { Message } from "../service/message.service";
import { RestService } from "../service/rest.service";
import { LoaderService } from "../service/loader.service";

@Component({
  selector: "app-UsersForceResetPassword",
  template: ` <std-modal
    *transloco="let t"
    cardClass="!max-w-[90vw]"
    headerClass="bg-primary"
    [show]="true"
    [closeOnOutside]="true"
    (close)="autoDestory()"
  >
    <div class="text-tertiary text-large" header>
      Manda email recupero password
    </div>
    <div content class="max-h-[70vh] overflow-y-scroll custom-scrollbar">
      <div class="text-primary text-medium">
        Sei sicuro di voler inviare l'email di recupero password a
        {{ fatherElement?.email }}
      </div>
      <div class="mt-4 flex gap-4 place-content-center">
        <std-button
          buttonClass="bg-primary focus:bg-primary hover:bg-primary"
          (click)="autoDestory()"
          class=""
          >{{ t("modal.cancel") }}</std-button
        >
        <std-button
          buttonClass="bg-primary focus:bg-primary hover:bg-primary"
          (click)="sendEmail()"
          class=""
          >{{ t("modal.confirm") }}</std-button
        >
      </div>
    </div>
  </std-modal>`,
  styles: [],
  standalone: false,
})
export class ForceResetEmailComponent implements OnInit {
  @Input() fatherElement: any = {};

  constructor(
    private host: ElementRef<HTMLElement>,
    private message: Message,
    private rest: RestService,
    private loader: LoaderService
  ) {}

  ngOnInit(): void {}

  autoDestory() {
    this.host.nativeElement.remove();
  }

  sendEmail() {
    this.loader.on();
    this.rest
      .post(api.endpoint.sendEmailRecovery, {
        email: this.fatherElement.email,
      })
      .subscribe({
        next: (value: any) => {
          this.loader.off(true);
          this.message.showMessage(
            "Email di recupero password inviata",
            "success",
            "message-fix-index"
          );
          this.autoDestory();
        },
        error: (error) => {
          this.loader.off(true);
          this.message.showMessage(
            error.error.message,
            "error",
            "message-fix-index"
          );
          this.autoDestory();
        },
      });
  }
}
